import { render, staticRenderFns } from "./invoiceServicesDetailedSummary.vue?vue&type=template&id=611a852e&"
import script from "./invoiceServicesDetailedSummary.vue?vue&type=script&lang=js&"
export * from "./invoiceServicesDetailedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports